<template>
  <div class="hris-logo">
    <VaIcon name="business_center" :size="iconSize" :color="colorsComputed.start" />
    <span class="hris-logo__text" :style="{ color: colorsComputed.start }">HRIS</span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 24,
    start: 'primary',
    end: undefined,
  },
)

const iconSize = computed(() => `${props.height}px`)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>

<style scoped>
.hris-logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.hris-logo__text {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: 0.05em;
}
</style>
